export const validateEmailForm = (data) =>{

    const requiredFields = [
        "email",
    ]

    var validFieldCount = 0
    
    requiredFields.forEach((field)=>{
        if(data[field]){
            validFieldCount = validFieldCount + 1
            // console.log(field , true)
        }else{
            // console.log(field , false)
        }
    })

    if(validFieldCount===requiredFields.length){
        return true
    }else{
        return false
    }
}

